import { render, staticRenderFns } from "./CompletedSection.vue?vue&type=template&id=9d568f12&scoped=true&"
import script from "./CompletedSection.vue?vue&type=script&lang=js&"
export * from "./CompletedSection.vue?vue&type=script&lang=js&"
import style0 from "./CompletedSection.vue?vue&type=style&index=0&id=9d568f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d568f12",
  null
  
)

export default component.exports